import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from '../../actions/actions';
import Avatar from '../Helpers/Avatar';
import { AlertForm, FormTextarea, FormWrapper } from '../Helpers/Form';
import './Messages.css';
import PateEntryRequest from './PateEntryRequest';

class Messages extends Component {
  constructor(props) {
    super(props);
    props.getAllRequests();
    props.getMessages();
  }

  render() {
    const {
      match,
      replySubmit,
      replyChange,
      acceptPateEntry,
      messageVm,
      authVm: { uid }
    } = this.props;
    const {
      requestMap,
      conversationPartners,
      message,
      messages,
      petsMap
    } = messageVm;
    const { selectedRequestId } = match.params;
    return (
      <div className="messages">
        {requestMap && requestMap.size === 0 ? (
          <p>Keine Nachrichten vorhanden</p>
        ) : (
          Array.from(requestMap).map(([key, request]) => {
            const conversationPartnerUid =
              uid === request.fromUid ? request.toUid : request.fromUid;
            const conversationsPartner = conversationPartners.get(conversationPartnerUid);

            return (
              <div key={key}>
                {conversationsPartner && (
                  <div className="owner">
                    <section>
                      <Link to={`/messages/${key}`} alt={key}>
                        <Avatar {...conversationsPartner} />
                        <div>{conversationsPartner.displayName}</div>
                      </Link>
                    </section>
                    <section>
                      <Link
                        to={`/user/${conversationPartnerUid}`}
                        alt={conversationPartnerUid}
                      >
                        <div>Zum Profil</div>
                      </Link>
                    </section>
                    <section />
                  </div>
                )}

                {selectedRequestId === key && (
                  <div className="message">
                    <div className="request">
                      {request && (
                        <PateEntryRequest
                          {...request}
                          uid={uid}
                          id={key}
                          petsMap={petsMap}
                          acceptPateEntry={pateEntryId =>
                            acceptPateEntry(pateEntryId)
                          }
                        />
                      )}
                    </div>
                    {messages.filter(m => m.requestUid === key).map(m => (
                      <div
                        key={m.id}
                        className={classnames(uid !== m.fromUid ? 'from' : 'to')}
                      >
                        {m.message}
                      </div>
                    ))}
                    <AlertForm
                      onSubmit={() =>
                        replySubmit(key, conversationPartnerUid, message)
                      }
                      className="reply"
                      onChange={({ name, value }) => replyChange(name, value)}
                    >
                      <FormTextarea value={message} name="message" />
                      <FormWrapper>
                        <button className="button">Senden</button>
                      </FormWrapper>
                    </AlertForm>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    ...state.messagesReducer,
    ...state.authReducer,
    ...state.alertReducer
  }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Messages);



// WEBPACK FOOTER //
// ./src/pages/Messages/index.js